import { DataGridPro, gridClasses } from "@mui/x-data-grid-pro";
import { styled } from "@mui/material";

export const StyledDataGrid = styled(DataGridPro)(
  ({
    theme: {
      palette: { custom },
      typography: { body2 }
    }
  }) => `
    border: 0;
    background-color: ${custom.background};
    font-family: "Maven Pro";
    color: ${custom.white.main};

    & .${gridClasses.overlay} {
      background-color: ${custom.white.dark};

      & .MuiDataGrid-skeletonLoadingOverlay {
        background-color: ${custom.background};
      }

      & .${gridClasses.cellSkeleton} {
        & .MuiSkeleton-root {
          background-color: ${custom.white.dark};
        }
      }

      & .MuiLinearProgress-root {
        background-color: ${custom.turquoise.dark};

        & .MuiLinearProgress-bar {
          background-color: ${custom.turquoise.main};
        }
      }
    }

    & .${gridClasses.filler} {
      background-color: ${custom.background};
      --DataGrid-rowBorderColor: #00000012;

      & .${gridClasses["filler--pinnedLeft"]} {
        background-color: ${custom.background};
      }
    }

    & .${gridClasses["row--borderBottom"]} {
      --DataGrid-t-color-background-base: ${custom.background};
      background-color: ${custom.background};

      & .${gridClasses.columnHeader} {
        background-color: ${custom.background};
        border-bottom: 1px solid #00000012;

        & .${gridClasses["row--borderBottom"]} {
          --DataGrid-t-color-background-base: ${custom.background};
          background-color: ${custom.background};
        }

        &.${gridClasses["columnHeader--withRightBorder"]} {
          border-right: none;
        }

        & .${gridClasses.columnSeparator} {
          &:not(.${gridClasses["columnSeparator--resizable"]}) {
            display: none;
          }
        }

        & .${gridClasses.sortButton} {
          color: ${custom.white.light};
        }

        & .${gridClasses.columnHeaderTitleContainerContent} {
          font-size: ${body2.mobile.fontSize};
          font-weight: 500;
          line-height: ${body2.mobile.lineHeight};

          & .MuiCheckbox-root > .MuiSvgIcon-root {
            fill: ${custom.turquoise.main};
          }
        }

        &:focus, &:focus-within {
          outline: none;
        }
      }
    }

    & .${gridClasses.row} {
      --rowBorderColor: ${custom.grey.lightest};

      & .${gridClasses.cell} {
        &:focus, &:focus-within {
          outline: none;
        }
      }

      &:hover {
        background-color: ${custom.background};

        & .${gridClasses.cellCheckbox} {
          background-color: ${custom.background};
        }
      }

      & .${gridClasses["cell--withRightBorder"]} {
        border-right: none;
      }
    }

    & .${gridClasses.footerContainer} {
      border-color: ${custom.grey.lightest};
    }
  `
);
